export const subscriptionTableStyles = {
  container: { height: '100vh' },
};
